export default {
    state: {
        vendors: [],
        vendor: [],
        vendor_facilities: [],
        vendor_units: [],
        vendor_admissions: [],
        vendor_inspections: [],
        vendor_billings: [],
        stats: [],
        comments: [],
        histories: [],
        vendor_id: null,
        errors: {},
        url: '/api/hms/vendors',
        form: {
            name: '',
            address: '',
            city: '',
            state_id: '',
            zip: '',
            date: null,
            contact: '',
            phone: '',
            email: '',
            fax: '',
        },
        other_form: {},
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        facilities_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        units_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        admissions_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        inspections_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        billings_meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'name', label: 'Name', sortable: true},
                {key: 'address', label: 'Address', sortable: true, tdClass: 'text-muted'},
                {key: 'phone', label: 'Phone', sortable: true, tdClass: 'text-muted'},
                {key: 'active', label: 'Status', sortable: true, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        }
    },

    getters: {
        getVendors: state => state.vendors,

        getVendor: state => state.vendor,

        getVendorFacilities: state => state.vendor_facilities,

        getVendorUnits: state => state.vendor_units,

        getVendorAdmissions: state => state.vendor_admissions,

        getVendorInspections: state => state.vendor_inspections,

        getVendorBillings: state => state.vendor_billings,

        getVendorStats: state => state.stats,

        getVendorComments: state => state.comments,

        getVendorHistories: state => state.histories,

        getVendorForm: state => state.form,

        getVendorsMeta: state => state.meta,

        getVendorFacilitiesMeta: state => state.facilities_meta,

        getVendorUnitsMeta: state => state.units_meta,

        getVendorAdmissionsMeta: state => state.admissions_meta,

        getVendorInspectionsMeta: state => state.inspections_meta,

        getVendorBillingsMeta: state => state.billings_meta,

        getVendorErrors: state => state.errors,

        getVendorOtherForm: state => state.other_form,

        getVendorTableFields: state => state.table.fields,
    },

    mutations: {
        setVendors: (state, payload) => {
            state.vendors = payload;
        },

        setVendor: (state, payload) => {
            state.vendor_id = payload.vendor_id;
            state.vendor = payload;
        },

        setVendorFacilities: (state, payload) => {
            state.vendor_facilities = payload;
        },

        setVendorUnits: (state, payload) => {
            state.vendor_units = payload;
        },

        setVendorAdmissions: (state, payload) => {
            state.vendor_admissions = payload;
        },

        setVendorInspections: (state, payload) => {
            state.vendor_inspections = payload;
        },

        setVendorBillings: (state, payload) => {
            state.vendor_billings = payload;
        },

        setVendorsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setVendorFacilitiesMeta: (state, payload) => {
            state.facilities_meta = {...state.facilities_meta, ...payload};
        },

        setVendorUnitsMeta: (state, payload) => {
            state.units_meta = {...state.units_meta, ...payload};
        },

        setVendorAdmissionsMeta: (state, payload) => {
            state.admissions_meta = {...state.admissions_meta, ...payload};
        },

        setVendorInspectionsMeta: (state, payload) => {
            state.inspections_meta = {...state.inspections_meta, ...payload};
        },

        setVendorBillingsMeta: (state, payload) => {
            state.billings_meta = {...state.billings_meta, ...payload};
        },

        setVendorErrors: (state, payload) => {
            state.errors = payload;
        },

        setVendorStats: (state, payload) => {
            state.stats = payload;
        },

        setVendorComments: (state, payload) => {
            state.comments = payload;
        },

        setVendorHistories: (state, payload) => {
            state.histories = payload;
        },

        setVendorForm: state => {
            state.form = {
                name: '',
                address: '',
                city: '',
                state_id: '',
                zip: '',
                date: null,
                contact: '',
                phone: '',
                email: '',
                fax: '',
            };

            state.errors = {};
        },

        resetVendorsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setVendorOtherForm: state => {
            state.other_form = {
                active: state.vendor.data.attributes.status === 'Active',
                body: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchVendors: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url, {params: parameters})
                    .then(response => {
                        commit('setVendors', response.data);

                        commit('setVendorsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setVendorErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchVendor: ({state, commit}, vendor_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id)
                    .then(response => {
                        commit('setVendor', response.data);
                        commit('setVendorOtherForm', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitVendor: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setVendorErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateVendor: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.vendor_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setVendorErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteVendor: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.vendor_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        fetchEditVendor: ({state, commit}, vendor_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/edit')
                    .then(response => {
                        state.vendor_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitVendorStatus: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.vendor_id + '/status', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setVendorErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitVendorComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.vendor_id + '/comments', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setVendorErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        fetchVendorStats: ({state, commit}, vendor_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/stats')
                    .then(response => {
                        commit('setVendorStats', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchVendorComments: ({state, commit}, vendor_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/comments')
                    .then(response => {
                        commit('setVendorComments', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchVendorHistories: ({state, commit}, vendor_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/histories')
                    .then(response => {
                        commit('setVendorHistories', response.data.data);

                        resolve(response.data.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchVendorFacilities: ({state, commit}, vendor_id) => {
            let parameters = {
                page: state.facilities_meta.current_page,
                per_page: state.facilities_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/facilities', {params: parameters})
                    .then(response => {
                        commit('setVendorFacilities', response.data);

                        commit('setVendorFacilitiesMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchVendorUnits: ({state, commit}, vendor_id) => {
            let parameters = {
                page: state.units_meta.current_page,
                per_page: state.units_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/units', {params: parameters})
                    .then(response => {
                        commit('setVendorUnits', response.data);

                        commit('setVendorUnitsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchVendorAdmissions: ({state, commit}, vendor_id) => {
            let parameters = {
                page: state.admissions_meta.current_page,
                per_page: state.admissions_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/admissions', {params: parameters})
                    .then(response => {
                        commit('setVendorAdmissions', response.data);

                        commit('setVendorAdmissionsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchVendorInspections: ({state, commit}, vendor_id) => {
            let parameters = {
                page: state.inspections_meta.current_page,
                per_page: state.inspections_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/inspections', {params: parameters})
                    .then(response => {
                        commit('setVendorInspections', response.data);

                        commit('setVendorInspectionsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchVendorBillings: ({state, commit}, vendor_id) => {
            let parameters = {
                page: state.billings_meta.current_page,
                per_page: state.billings_meta.per_page,
            };

            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + vendor_id + '/billings', {params: parameters})
                    .then(response => {
                        commit('setVendorBillings', response.data);

                        commit('setVendorBillingsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject();
                    });
            });
        },

        fetchEditVendorComment: ({state, commit}, comment_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + state.vendor_id + '/comments/' + comment_id + '/edit')
                    .then(response => {
                        state.other_form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        updateVendorComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.vendor_id + '/comments/' + payload.id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setVendorErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteVendorComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + state.vendor_id + '/comments/' + payload.comment_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    },
}
